import axios from 'axios'
import config from './config'
import router from '../router/index'

const baseURL = config.baseUrl;
const http = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type' : 'application/json; charset=UTF-8'
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
});
http.interceptors.request.use(config => {
  //config是axios配置对象
  //每次发送请求前都会进入此拦截器处理函数，可以在此处统一携带上token，每次请求都会自
  // config.headers['token'] = localStorage.getItem('token');
  return config
},err => {
  //请求出错的处理函数
  return Promise.reject(err)
})
// 添加响应拦截器
http.interceptors.response.use( (response)=> {
  // 对响应数据做点什么
  return response;
},  (error)=> {
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default http




// WEBPACK FOOTER //
// ./src/api/index.js